import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {AccountApplication} from "../types.ts";
import {useAccountApplication} from "../hooks/useAccountApplication.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        record,
        createRecord,
    } = useAccountApplication();

    return (
        <FormDrawer
            record={record ?? {} as AccountApplication}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
